import React from 'react';
import { useNavigate } from 'react-router-dom';
import SaveButton from '../common/SaveButton';
import UserMenu from '../common/UserMenu';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  
  const goToHome = () => {
    navigate('/');
  };
  
  // CSS for custom hover effect
  const logoStyle = {
    transition: 'transform 0.3s ease'
  };
  
  const logoHoverStyle = {
    transform: 'scale(1.02)'
  };
  
  return (
    <header className="relative w-full py-3 mb-6">
      {/* Premium background with gradient and rounded bottom corners */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-50 via-white to-blue-50 rounded-b-2xl shadow-md"></div>
      
      <div className="container mx-auto px-4 relative">
        <div className="flex items-center justify-between">
          {/* Logo with custom hover effect and click functionality */}
          <div 
            className="flex items-center cursor-pointer"
            onClick={goToHome}
            style={logoStyle}
            onMouseOver={(e) => Object.assign(e.currentTarget.style, logoHoverStyle)}
            onMouseOut={(e) => e.currentTarget.style.transform = ''}
          >
            <img
              src="/new-logo-blue.png"
              alt="Careers Compass"
              className="h-12 md:h-14 object-contain"
            />
          </div>
          
          {/* User account and save buttons - only shown if logged in */}
          {currentUser && (
            <div className="flex items-center space-x-4">
              <SaveButton />
              <UserMenu />
            </div>
          )}
        </div>
      </div>
      
      {/* Decorative accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-blue-400 via-blue-500 to-blue-400 opacity-80 rounded-full mx-8"></div>
    </header>
  );
};

export default Header;